import React from 'react';
import ThumbnailImage from '../common/ThumbnailImage';
import './DASHBOARD.css';

// 자사재고현황용 이미지 카드 컴포넌트 (API 데이터 기반)
const InventoryImageCard = ({ inventory, onImageClick }) => {
    return (
        <div className="dash-inventory-image-card">
            <div className="dash-inventory-image-header">
                <h4>{inventory.itemNm}</h4>
            </div>
            <div className="dash-inventory-image-content">
                <div className="dash-inventory-image-placeholder">
                    <ThumbnailImage
                        item={inventory}
                        style={{ width: '100%', height: '100%', borderRadius: '16px' }}
                        className="dash-inventory-thumbnail"
                        onClick={(e) => {
                            if (onImageClick) {
                                onImageClick(inventory);
                            }
                        }}
                    />
                </div>
                <div className="dash-inventory-item-details">
                    <div className="dash-inventory-item-specs">
                        <div className="dash-inventory-spec-row">
                            <span className="dash-inventory-spec-label">현재고:</span>
                            <span className="dash-inventory-spec-value">{inventory.closingQty?.toLocaleString() || 0}</span>
                        </div>
                        <div className="dash-inventory-spec-row">
                            <span className="dash-inventory-spec-label">현재고금액:</span>
                            <span className="dash-inventory-spec-value">{inventory.closingAmt?.toLocaleString() || 0}원</span>
                        </div>
                        <div className="dash-inventory-spec-row">
                            <span className="dash-inventory-spec-label">평균단가:</span>
                            <span className="dash-inventory-spec-client">{Math.round(inventory.avgPrice || 0).toLocaleString()}원</span>
                        </div>
                    </div>
                    {inventory.locCd ? (
                        <span className="dash-inventory-location-badge">
                            📍 {inventory.locCd}
                        </span>
                    ) : (
                        <span className="dash-inventory-no-location-badge">
                            📋 위치 미지정
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default InventoryImageCard;
